// 拷贝
export function clone(payload) {
    if (!payload) return ''
    return JSON.parse(JSON.stringify(payload))
}

// 数据处理
export function processing(payload) {
    if (Object.keys(payload).length < 1) return {}
    const newObjs = JSON.parse(JSON.stringify(payload))
    Object.keys(newObjs).forEach(item => {
        if (newObjs[item] === null || newObjs[item] === '' || newObjs[item] === '-1') {
            delete newObjs[item]
        }
    })
    return Object.keys(newObjs).length > 0 ? newObjs : {}
}

// 时间处理
export function formatDate(payload, status) {
    const date = new Date(payload)
    const year = date.getFullYear()
    let m = date.getMonth() + 1
    let d = date.getDate()
    m = m < 10 ? '0' + m : m
    d = d < 10 ? '0' + d : d
    if (status === 'start') return `${year}-${m}-${d}`
    return `${year}-${m}-${d}`
}

// 时间处理 + 时分秒
export function formatDatePolishing(payload, status) {
    const date = new Date(payload)
    const year = date.getFullYear()
    let m = date.getMonth() + 1
    let d = date.getDate()
    m = m < 10 ? '0' + m : m
    d = d < 10 ? '0' + d : d
    if (status === 'start') return `${year}-${m}-${d}` + ' 00:00:00'
    return `${year}-${m}-${d}` + ' 23:59:59'
}

export function unique(arr, uniId) {
  let hash = {}
  return arr.reduce((accum, item) => {
    hash[item[uniId]] ? '' : hash[item[uniId]] = true && accum.push(item)
    return accum
  }, [])
}
